<div class="area-to-overlay">

  <ngx-datatable style="width: 100%" class="colab-datatable colab-checkbox"
    [messages]="{emptyMessage: '', totalMessage: '', selectedMessage: ''}" [rows]="rows" [count]="rowsCount"
    [columnMode]="'force'" [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'" [externalPaging]="true"
    [externalSorting]="true" [limit]="10" [selected]="selected" [selectionType]="'checkbox'"
    [loadingIndicator]="loadingIndicator" [rowIdentity]="getId" (page)="onPage($event)" (sort)="onSort($event)"
    (select)='onSelect()' [scrollbarH]="true">

    <ngx-datatable-column [width]="40" [sortable]="false" [canAutoResize]="false" [draggable]="false"
      [resizeable]="false" [headerCheckboxable]="false" [checkboxable]="true">
    </ngx-datatable-column>

    <ngx-datatable-column name="Nome" prop="name" [width]="240" [canAutoResize]="true" [resizeable]="true">
      <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
        <span (click)="sort()">{{ 'COMPANY.MANAGER.COLABS.TABLE.COLUMNS.NAME' | translate }}</span>
      </ng-template>
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        <strong class="row-colab-name"><a
            [routerLink]="['/company/manage',{outlets:{colabmanagersection: ['edit', row['id']]}}]"
            [queryParams]="{employeeId: row['id']}">{{value}}</a></strong>
        <span class="row-colab-email"><a
            [routerLink]="['/company/manage',{outlets:{colabmanagersection: ['edit', row['id']]}}]"
            [queryParams]="{employeeId: row['id']}">{{ row['email']}}</a></span>

        <span class="mobile-row">{{ 'COMPANY.MANAGER.COLABS.TABLE.COLUMNS.PROFILE' | translate }}:
          {{ row['profilesId'] === '5a1ef473694cfe4bc3935212' ? 'Master' : '' }}
          {{ row['profilesId'] === '5a1ef50d694cfe4bc3935217' ? 'Funcionário' : '' }}
          {{ row['profilesId'] === '5a1ef4b2694cfe4bc3935213' ? 'Financeiro' : '' }}
          {{ row['profilesId'] === '5a1ef508694cfe4bc3935215' ? 'Comunicação' : '' }}
        </span>
        <span class="mobile-row">{{ 'COMPANY.MANAGER.COLABS.TABLE.COLUMNS.STATUS' | translate }}:
          {{ row['status'] === 'active' ? 'Ativo' : '' }}
          {{ row['status'] === 'not_invited' ? 'Não convidado' : '' }}
          {{ row['status'] === 'blocked' ? 'Bloqueado' : '' }}
          {{ row['status'] === 'hardbounce' ? 'Email com erro' : '' }}
          {{ row['status'] === 'invited' ? 'Convidado' : '' }}
          {{ row['status'] === 'invite-error' ? 'Erro no convite' : '' }}
        </span>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column *ngIf="typeBusiness === 'company'" name="Grupo" prop="group">
      <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
        <span (click)="sort()">{{ 'COMPANY.MANAGER.COLABS.TABLE.COLUMNS.GROUP' | translate }}
        </span>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Perfil" prop="profilesId">
      <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
        <span (click)="sort()">{{ 'COMPANY.MANAGER.COLABS.TABLE.COLUMNS.PROFILE' | translate }}
          <!-- Fase 2 -->
          <!-- <i tooltip="Esperando texto" class="fa fa-info-circle"></i> -->
        </span>
      </ng-template>
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        {{ value === '5a1ef473694cfe4bc3935212' ? 'Master' : '' }}
        {{ value === '5a1ef50d694cfe4bc3935217' ? 'Funcionário' : '' }}
        {{ value === '5a1ef4b2694cfe4bc3935213' ? 'Financeiro' : '' }}
        {{ value === '5a1ef508694cfe4bc3935215' ? 'Comunicação' : '' }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Status" prop="status">
      <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
        <span (click)="sort()">{{ 'COMPANY.MANAGER.COLABS.TABLE.COLUMNS.STATUS' | translate }}
          <!-- Fase 2 -->
          <!-- <i tooltip="Esperando texto" class="fa fa-info-circle"></i> -->
        </span>
      </ng-template>
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        {{ value === 'active' ? 'Ativo' : '' }}
        {{ value === 'not_invited' ? 'Não convidado' : '' }}
        {{ value === 'blocked' ? 'Bloqueado' : '' }}
        {{ value === 'hardbounce' ? 'Email com erro' : '' }}
        {{ value === 'invited' ? 'Convidado' : '' }}
        {{ value === 'invite-error' ? 'Erro no convite' : '' }}
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Data do cadastro" prop="created_date" [sortable]="false">
      <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
        <span (click)="sort()">{{ 'COMPANY.MANAGER.COLABS.TABLE.COLUMNS.CREATED_DATE' | translate }}</span>
      </ng-template>
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        <span *ngIf="value !== ''">{{ value | date:'dd/MM/yyyy' }}</span>
        <span *ngIf="value === ''">Nunca</span>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Envio do convite" prop="inviteSentDate" [sortable]="false">
      <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
        <span (click)="sort()">{{ 'COMPANY.MANAGER.COLABS.TABLE.COLUMNS.INVITE_DATE' | translate }}</span>
      </ng-template>
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        <span *ngIf="value !== ''">{{ value | date:'dd/MM/yyyy' }}</span>
        <span *ngIf="value === ''">Nunca</span>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Primeiro acesso" prop="firstAccess" [sortable]="false">
      <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
        <span (click)="sort()">{{ 'COMPANY.MANAGER.COLABS.TABLE.COLUMNS.FIRST_ACCESS' | translate }}</span>
      </ng-template>
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        <span *ngIf="value !== ''">{{ value | date:'dd/MM/yyyy' }}</span>
        <span *ngIf="value === ''">Nunca</span>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Último acesso" prop="lastActivity" [sortable]="false">
      <ng-template let-column="column" let-sort="sortFn" ngx-datatable-header-template>
        <span (click)="sort()">{{ 'COMPANY.MANAGER.COLABS.TABLE.COLUMNS.LAST_ACCESS' | translate }}</span>
      </ng-template>
      <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
        <span *ngIf="value !== ''">{{ value | date:'dd/MM/yyyy' }}</span>
        <span *ngIf="value === ''">Nunca</span>
      </ng-template>
    </ngx-datatable-column>

  </ngx-datatable>

  <div class="loading-overlay" *ngIf="isLoading">
    <div class="loader-wrp">
      <div class="loader"><span></span><span></span><span></span></div>
      <p> {{ 'LOADING' | translate }}</p>
    </div>
  </div>

  <div class="empty-row" *ngIf="rowsOriginalCollection.length === 0 && !loadingIndicator">{{
    'COMPANY.MANAGER.COLABS.TABLE.EMPTY_ROWS' | translate }}</div>
  <div class="empty-row" *ngIf="rows.length === 0 && rowsOriginalCollection.length > 0 && !loadingIndicator">{{
    'COMPANY.MANAGER.COLABS.TABLE.EMPTY_ROWS_FILTER' | translate }}</div>
</div>